import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Alert, Button, Col, InputGroup, Spinner } from "react-bootstrap";

import {
  get,
  put,
  isBDCLoggedIn,
  isClientLoggedIn,
  destroy,
} from "../../../utils/DeApi";
import { exportFilings } from "../../../utils/exportUtils";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import OptimizedFilingList from "../../OptimizedFiling/OptimizedFilingList/OptimizedFilingList";
import { isDevelopment } from "../../../utils/env";
import LoanDocumentFetch from "../../LoanDocumentFetch/LoanDocumentFetch";
import moment from "moment";
import toast from "react-hot-toast";
import OptimizedFilingListPgm from "../../OptimizedFiling/OptimizedFilingList/OptimizedFilingListPgm";

class OptimizedSearchResultsPgm extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    var startTime = new Date(props.filedAt);
    var endTime = new Date(startTime.getDate() + 1);
    this.state = {
      filings: [],
      catalogue: [],
      startTime: startTime.setHours(0),
      endTime: endTime.setHours(0),
      searched: "",
      searchContainer: [],
      showModal: false,
      selections: this.props?.selections,
      analystList: [],
      selectedFiles: [],
      assignedAnalyst: [],
      analystToRemove: [],
      allFilesSelected: false,
      selectedAnalyst: null,
      isAssignAnalystLoading: false,
      isAssignAnalystSuccess: false,
      isAssignAnalystError: false,
      isRemoveAnalystLoading: false,
    };
    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleModal = this._handleModal.bind(this);
    this._handleCikApi = this._handleCikApi.bind(this);
    this.child = React.createRef();
  }

  componentDidMount() {
    localStorage.setItem("filedAt", this.props.filedAt);
    this.searchFilings();
    this.fetchCatalogue();
    this.fetchSelections();
    this.fetchAnalyst();
    // this.fetchAssignedCatalogues();
  }

  async searchFilings() {
    const { filedAt } = this.props;
    this.setState({ error: null, isLoading: true });

    try {
      const analystPromise = await get(
        `/assigned/catalogues?filedAt=${filedAt}`
      ).promise;

      const searchFillingPromise = await get(
        "search/newcron/filings/training",
        {
          params: { filedAt: filedAt, offset: 0, limit: 5000 },
        }
      ).promise;

      const combineFillingWithAnalyst = searchFillingPromise?.data?.map(
        (fillingItem) => {
          const analystInfo = analystPromise?.data?.find(
            (analystItem) => analystItem.filingId === fillingItem.id
          );

          return {
            ...fillingItem,
            analystAssigned: analystInfo?.analyst_name || null,
          };
        }
      );

      this.setState({
        filings: combineFillingWithAnalyst,
        searchContainer: combineFillingWithAnalyst,
        filingsMeta: searchFillingPromise.meta,
        error: null,
        isLoading: false,
      });
    } catch (error) {
      console.log("error", error);
      !error.isCanceled &&
        this.setState({
          error: { message: error.code, code: error.code },
          isLoading: false,
        });
    }
  }

  async fetchFilings(docs, filedAt) {
    if (!docs.length) {
      this.setState({
        filings: [],
        filingsMeta: { totals: 0 },
        error: null,
        isLoading: false,
      });
      return;
    }

    this.setState({ error: null, isLoading: true });
    const accessionNos = docs.map(
      (item) => 'accessionNo:"' + item.accessionNo + '"'
    );

    const filingsQuery = accessionNos.length ? accessionNos.join(" OR ") : '""';

    const searchFilingsPromise = get("/search/filings", {
      params: {
        filedAt: filedAt,
        q: filingsQuery,
        offset: 0,
        limit: 5000,
      },
    });
    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          filings: response.data,
          searchContainer: response.data,
          filingsMeta: response.meta,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
    this.subscribedPromises.push(searchFilingsPromise);
  }

  fetchSelections() {
    const { filedAt } = this.props;
    this.setState({ selectionsError: null, selectionsIsLoading: true });

    const selectionsPromise = get("/catalogues", {
      params: { filedAt: filedAt },
    });
    selectionsPromise.promise
      .then((response) => {
        this.setState({
          selections: response.data,
          selectionsError: null,
          selectionsIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ selectionsError: error, selectionsIsLoading: false });
      });
    this.subscribedPromises.push(selectionsPromise);
  }

  fetchCatalogue() {
    const { filedAt } = this.props;
    this.setState({ catalogueError: null, catalogueIsLoading: true });

    const cataloguesPromise = get("/catalogues", {
      params: {
        filedAt: filedAt,
        fromSection: "catalogue",
        inventories: [
          "609a925cd40db",
          "609a925ccd422",
          "609a925cc94f7",
          "609a925ccf235",
          "609a925cd1714",
        ],
      },
    });
    cataloguesPromise.promise
      .then((response) => {
        this.setState({
          catalogue: response.data,
          catalogueError: null,
          catalogueIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ catalogueError: error, catalogueIsLoading: false });
      });
    this.subscribedPromises.push(cataloguesPromise);
  }

  fetchAnalyst() {
    const analystPromise = get("/analyst/list");
    analystPromise.promise
      .then((response) => {
        this.setState((prev) => ({
          ...prev,
          analystList: response?.data?.analysts || [],
        }));
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ analyistListError: error });
      });

    this.subscribedPromises.push(analystPromise);
  }

  fetchAssignedCatalogues() {
    const filedAt = moment(this.state.startTime).format("YYYY-MM-DD");
    const assignedCatalogues = get(`/assigned/catalogues?filedAt=${filedAt}`);

    assignedCatalogues.promise
      .then((response) => {
        this.setState((prev) => ({
          ...prev,
          assignedAnalyst: response?.data || [],
        }));
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ catalogueError: error, catalogueIsLoading: false });
      });
  }

  /* *** handle change function for the search-field *** */
  _handleInputChange(input) {
    if (input?.target?.value) {
      this.setState({ searched: input.target.value });
      this.search(input.target.value);
    } else {
      this.setState({ searched: "" }, () => {
        this.search();
      });
    }
  }

  _handleModal() {
    this.setState({
      showModal: true,
    });
  }

  _handleCikApi(data) {
    const { filings } = this.state;
    this.setState({
      filings: [...filings, data],
    });
  }

  handleCheckboxChange = (e, filing) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // add a filings to state when checkbox is checked
      const data = {
        filingId: filing.id,
        formType: filing.formType,
      };

      this.setState(
        (prevState) => ({
          selectedFiles: [...prevState.selectedFiles, data],
        }),
        () => {
          const analystList = this.state.selectedFiles
            .map((file) => {
              return this.state.assignedAnalyst.find(
                (docData) => docData.filingId === file.filingId
              );
            })
            .filter(Boolean);
          this.setState((prev) => ({
            analystToRemove: [...analystList],
          }));
        }
      );
    } else {
      // remove a filing from state when checkbox is unchecked
      this.setState((prevState) => ({
        ...prevState,
        allFilesSelected: false,
      }));
      this.setState(
        (prevState) => ({
          selectedFiles: prevState.selectedFiles.filter((file) => {
            return file.filingId !== filing.id;
          }),
        }),
        () => {
          const analystList = this.state.selectedFiles
            .map((file) => {
              return this.state.assignedAnalyst.find(
                (docData) => docData.filingId === file.filingId
              );
            })
            .filter(Boolean);
          this.setState((prev) => ({
            analystToRemove: [...analystList],
          }));
        }
      );
    }
  };

  handleCheckAllChange = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // add all filings to state when header checkbox is checked
      this.setState((prevState) => ({
        ...prevState,
        allFilesSelected: true,
      }));
      const data = this.state.filings.map((filing) => ({
        filingId: filing.id,
        formType: filing.formType,
      }));
      this.setState(
        (prevState) => ({
          ...prevState,
          selectedFiles: [...data],
        }),
        () => {
          const analystList = this.state.selectedFiles
            .map((file) => {
              return this.state.assignedAnalyst.find(
                (docData) => docData.filingId === file.filingId
              );
            })
            .filter(Boolean);
          this.setState((prev) => ({
            analystToRemove: [...analystList],
          }));
        }
      );
    } else {
      // remove all filings from state when header checkbox is unchecked

      this.setState((prevState) => ({
        ...prevState,
        allFilesSelected: false,
        selectedFiles: [],
        analystToRemove: [],
      }));
    }
  };

  handleAssignAnalyst = () => {
    const filedAt = moment(this.state.startTime).format("YYYY-MM-DD");

    // Add loader and submit form
    this.setState({ isAssignAnalystLoading: true });

    const payload = {
      analystId: this.state.selectedAnalyst.id,
      analystEmail: this.state.selectedAnalyst.email,
      documents: JSON.stringify(this.state.selectedFiles),
    };

    const analystPromise = put(
      `/assign/multiple/catalogues/${filedAt}`,
      payload
    );

    analystPromise.promise
      .then((response) => {
        this.setState({
          isAssignAnalystLoading: false,
          isAssignAnalystError: false,
          isAssignAnalystSuccess: true,
          allFilesSelected: false,
        });

        toast.success("Analyst Assigned Successfully!");
        // this.fetchAssignedCatalogues();
        this.searchFilings();
      })
      .catch((error) => {
        console.log(error);
        !error.isCanceled &&
          this.setState({
            isAssignAnalystError: error,
            isAssignAnalystLoading: false,
          });

        toast.error("Something went wrong!");
      });
  };

  handleRemoveAnalyst = () => {
    const { analystToRemove } = this.state;

    for (const analyst of analystToRemove) {
      const analystPromise = destroy(
        `assignment/delete/${analyst.filingId}/${analyst.analyst_id}`
      );

      analystPromise.promise
        .then((response) => {
          this.setState((prev) => ({
            ...prev,
            assignedAnalyst: this.state.assignedAnalyst.filter(
              (docData) => docData.filingId !== analyst.filingId
            ),
            selectedFiles: [],
            analystToRemove: [],
            allFilesSelected: false,
          }));
          this.searchFilings();
        })

        .catch((error) => {
          console.log(error);
          toast.error("Something went wrong!");
        });
    }
  };

  /* *** filter filing collection for a search ( below ) *** */
  search(value = "") {
    const { searchContainer } = this.state;
    if (value !== null && value !== "") {
      this.setState({
        filings: searchContainer.filter(
          (record) =>
            record.companyName.toLowerCase().includes(value.toLowerCase()) ||
            record.cik.includes(value)
        ),
      });
    } else {
      this.setState({ filings: searchContainer });
    }
    if (this.child && this.child.current && this.child.current !== null) {
      this.child.current.updateStateData();
    }
  }

  _renderFilings() {
    const {
      filings,
      selections,
      catalogue,
      filingsMeta,
      searched,
      assignedAnalyst,
    } = this.state;

    const user = this.props?.user;
    if (filings?.length) {
      return (
        <OptimizedFilingListPgm
          filings={filings}
          ref={this.child}
          user={user}
          filingsMeta={filingsMeta}
          catalogue={catalogue}
          btnShow={true}
          selections={selections || []}
          searcheValue={searched}
          onCatalogueAdd={(catalogued) => {
            this.setState({ selections: [...selections, ...[catalogued]] });
          }}
          onCatalogueRemove={(catalogued) => {
            this.setState({
              selections: selections.filter(
                (item) => item.id !== catalogued.id
              ),
            });
          }}
          queryByFetch={this.state.queryByFetch}
          handleCheckboxChange={this.handleCheckboxChange}
          handleCheckAllChange={this.handleCheckAllChange}
          allFilesSelected={this.state.allFilesSelected}
          selectedFiles={this.state.selectedFiles}
          assignedAnalyst={assignedAnalyst}
          sortable
        />
      );
    }
    return (
      <Col sm>
        <Col sm>
          <Alert
            variant="default"
            className="alert-deal-style w-100 shadow mr-1"
          >
            <h4 className="mb-0">
              No relevant filings found for this search criteria.
            </h4>
          </Alert>
        </Col>
      </Col>
    );
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function (promise) {
      promise.cancel();
    });
  }

  render() {
    const {
      filings,
      filingsMeta,
      isLoading,
      error,
      selections,
      searched,
      showModal,
      analystList,
      selectedFiles,
      selectedAnalyst,
      isAssignAnalystLoading,
      isAssignAnalystError,
      assignedAnalyst,
      analystToRemove,
      isRemoveAnalystLoading,
    } = this.state;
    const { filedAt, user } = this.props;
    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    if (isAssignAnalystError)
      return <ErrorHandler error={isAssignAnalystError} />;

    return (
      <>
        <div
          className="sticky"
          style={{
            width: "100%",
            zIndex: "100",
            paddingLeft: "1%",
          }}
          id="main_sticky"
        >
          <div className="d-flex justify-content-between align-items-center">
            {this.props.searchForm}
            {/* <div className="d-flex align-items-center ml-5">
              <p className="mb-inherit flex-5">Analyst</p>
              <select
                className="btn border-bottom roundedEdges px-3 py-2 ml-2 flex-2"
                disabled={isAssignAnalystLoading}
                onChange={(e) => {
                  const { value } = e.target;
                  this.setState((prev) => ({
                    ...prev,
                    selectedAnalyst: JSON.parse(value),
                  }));
                }}
              >
                <option selected disabled value={null}>
                  Assign to
                </option>
                {analystList.map((analyst) => (
                  <option
                    key={analyst.id}
                    value={JSON.stringify({
                      email: analyst.email,
                      id: analyst.id,
                    })}
                  >
                    {analyst.name}
                  </option>
                ))}
              </select>
              <div className="d-flex justify-content-between align-items-center">
                <Button
                  size="md"
                  block
                  className="ml-1 btn btn-success-deal-style roundedEdges flex-1"
                  disabled={
                    selectedFiles.length <= 0 ||
                    selectedAnalyst === null ||
                    isAssignAnalystLoading
                  }
                  onClick={this.handleAssignAnalyst}
                >
                  {isAssignAnalystLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      className="mb-1"
                      variant="light"
                      size="sm"
                    />
                  ) : (
                    <span>Assign</span>
                  )}
                </Button>
                <Button
                  size="md"
                  block
                  className="ml-1 mt-0 btn btn-danger roundedEdges flex-1"
                  disabled={analystToRemove.length <= 0}
                  onClick={this.handleRemoveAnalyst}
                >
                  {isRemoveAnalystLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      className="mb-1"
                      variant="light"
                      size="sm"
                    />
                  ) : (
                    <span>Remove</span>
                  )}
                </Button>
              </div>
            </div> */}

            {selectedFiles.length > 0 && (
              <div className="col-xs-2 ml-auto ">
                <small className="mt-0 mb-0 btn btn-outline-deal-style roundedEdges shadow">
                  <span>{selectedFiles?.length || 0} Selected</span>
                </small>
              </div>
            )}

            <div
              className="input-group float-right col-xs-2 shadow roundedEdges ml-auto"
              style={{ width: "20%", marginRight: "0%" }}
            >
              {/* <input
                type="text"
                className="form-control roundedEdges"
                placeholder="Search Filings"
                onChange={this._handleInputChange}
                value={searched}
              /> */}
            </div>

            {this.renderFilters(selections, filedAt, filingsMeta)}

            <div className="float-right col-xs-2 floated-export-optimized-search">
              {/* <a
                href="#"
                className="override-anchor-effect"
                style={{ zIndex: "1000" }}
                variant="outline-deal-style"
                size="xs"
                onClick={() => {
                  exportFilings(
                    filings.map((f) => ({
                      ...f,
                      assignedAnalyst: assignedAnalyst.find(
                        (docData) => docData.filingId === f.id
                      ),
                    })),
                    filedAt + "-search-results.csv"
                  );
                }}
              >
                Export{" "}
                <span className="material-icons color-deal-style">
                  description
                </span>
              </a> */}
            </div>
          </div>
        </div>
        {this._renderFilings()}
        {isLoading && <Loader />}
        {error && <ErrorHandler error={error} />}
        <LoanDocumentFetch
          user={user}
          show={showModal}
          onClose={(val) => this.setState({ showModal: val })}
          onElasticState={this._handleCikApi}
          filedAt={filedAt}
        />
      </>
    );
  }

  renderFilters(selections, filedAt, filingsMeta) {
    var startTimes = [];
    for (let index = 0; index < 24; index++) {
      if (index < 10) startTimes.push(`0${index}:00`);
      else startTimes.push(`${index}:00`);
    }

    var endTimes = [];
    for (let index = 0; index < 24; index++) {
      if (index < 10) endTimes.push(`0${index}:59`);
      else endTimes.push(`${index}:59`);
    }
    return (
      <div className="d-flex align-items-center" id="filters_control">
        {/* <div className="ml-2">
          {!isBDCLoggedIn() && !isClientLoggedIn() ? (
            <button
              className="
                    btn 
                    btn-outline-deal-style 
                    roundedEdges 
                    shadow"
              onClick={this._handleModal}
            >
              Fetch Document
            </button>
          ) : null}
        </div> */}
        {/* <div className="flex flow-control" style={{ paddingLeft: "10px" }}>
          {filingsMeta && (
            <small>
              <Link
                className="
                      btn 
                      btn-outline-deal-style 
                      roundedEdges 
                      shadow  
                    "
                to={`selections/show`}
              >
                <span>
                  {filingsMeta.totals || 0} Files / {selections?.length || 0}{" "}
                  Selected
                </span>
              </Link>
            </small>
          )}{" "}
        </div> */}
      </div>
    );
  }
}
OptimizedSearchResultsPgm.propTypes = {
  filedAt: PropTypes.string.isRequired,
};

export default OptimizedSearchResultsPgm;
